import type { ICampaignType, IVariantType } from '~/modules/campaign/types';

import { TOOLTIP_CAMPAIGN_VARIANT } from '~/modules/campaign/constants';
import { GVariantBadge, GTextTooltip } from '~/presentation/ui';
import { VARIANT_BADGE_CONFIG } from '../constants';
import { InlineStack } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

interface MobileVariantHeaderProps {
  variantType: IVariantType;
  campaignType: ICampaignType;
}

export const MobileVariantHeader: React.FC<MobileVariantHeaderProps> = ({
  variantType,
  campaignType,
}) => {
  const { t } = useTranslation();
  const config = VARIANT_BADGE_CONFIG[variantType];

  return (
    <InlineStack gap="200" blockAlign="center">
      <GVariantBadge
        variant={config.variant}
        tone={config.tone}
        size="sm"
        labelProps={{ variant: 'bodyMd', fontWeight: 'medium' }}
      />
      <GTextTooltip
        tooltipProps={{ content: TOOLTIP_CAMPAIGN_VARIANT[campaignType][variantType] }}
        as="p"
        variant="bodyMd"
        fontWeight="semibold"
      >
        {t(config.labelKey)}
      </GTextTooltip>
    </InlineStack>
  );
};
